/**
 * OaSIS Explorer Frontend - Application Entry Point
 * Task 3.1: Frontend Foundation & Global Features
 * 
 * Main entry point with React 19 setup
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';

// Get root element
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

// Create root and render app
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);